import { TEXT, IMAGE, LINK, VIDEO, MENTION, FRAME, ANIMATION, TITLE } from './types';
import TextEntity from './text-entity';
import ImageEntity from './image-entity';
import LinkEntity from './link-entity';
import VideoEntity from './video-entity';
import MentionEntity from './mention-entity';
import FrameEntity from './frame-entity';
import AnimationEntity from './animation-entity';

export { parse, fromJSON };

function getEntityClass(type) {
  switch (type.toLowerCase()) {
    case TEXT:
      return TextEntity;
    case IMAGE:
      return ImageEntity;
    case LINK:
      return LinkEntity;
    case VIDEO:
      return VideoEntity;
    case MENTION:
      return MentionEntity;
    case FRAME:
      return FrameEntity;
    case ANIMATION:
      return AnimationEntity;
    case TITLE:
      return TextEntity;
    default:
      return null;
  }
}

function parse(type, data) {
  var EntityClass = getEntityClass(type),
    entity = null;

  if (EntityClass) {
    entity = new EntityClass();
    entity = entity.parse(data);
  }

  return entity;
}

function fromJSON(type, json) {
  var EntityClass = getEntityClass(type),
    entity = null;

  if (EntityClass) {
    entity = EntityClass.fromJSON(json);
  }

  return entity;
}
